<div class="executed-container d-flex w-100 mb-4">
  <div class="executed-content-container w-100">
    <div class="registered-action-executed-container">
      <ng-container *ngIf="submitting; else showExecutionInfo">
        <mat-spinner color="primary" diameter="24"></mat-spinner>
      </ng-container>
      <ng-template #showExecutionInfo>
        <div>
          <mat-checkbox
            [(ngModel)]="executed"
            (ngModelChange)="executedChanged()"
          >
            Uitgevoerd
          </mat-checkbox>
        </div>
        <div
          *ngIf="executed && placementDoneRegistration != null"
          class="align-with-registration-checkbox"
        >
          <i
            >Geregistreerd door
            <ng-container
              *ngIf="
                placementDoneRegistration.user != null;
                else registrationBy
              "
            >
              {{
                placementDoneRegistration.user?.firstName
                  | personName: placementDoneRegistration.user?.lastName
              }}
            </ng-container>
            <ng-template #registrationBy>
              {{
                placementDoneRegistration.by?.firstName
                  | personName: placementDoneRegistration.by?.lastName
              }}
            </ng-template>
            op
            {{
              placementDoneRegistration.date | formatDate: '':'dd/MM/yyyy HH:mm'
            }}</i
          >
        </div>
      </ng-template>
    </div>

    <ng-container
      *ngIf="
        subProject.type === SUB_PROJECT_TYPES.BASE_PROJECT;
        else adjustmentExecutionAssets
      "
    >
      <file-picker
        *ngIf="firstIPBoardProduct != null"
        [formSection]="'execution'"
        [inputProduct]="firstIPBoardProduct"
        [uploadButtonLabel]="'Foto plaatsing toevoegen'"
        [noLeftSpace]="true"
        [hideUploadedImages]="true"
        (answer)="calculateExecutionAssets()"
        (assetDeleted)="calculateExecutionAssets()"
      ></file-picker>
    </ng-container>
    <ng-template #adjustmentExecutionAssets>
      <file-picker
        *ngIf="subProject.type !== SUB_PROJECT_TYPES.REPO"
        [formSection]="'adjustmentPlacementSuccess'"
        [inputProjectPlacement]="subProject.projectPlacement"
        [uploadButtonLabel]="'Foto plaatsing toevoegen'"
        [noLeftSpace]="true"
        [hideUploadedImages]="true"
        (answer)="calculateExecutionAssets()"
        (assetDeleted)="calculateExecutionAssets()"
      ></file-picker>
    </ng-template>

    <textarea-input
      *ngIf="executed"
      [initContent]="installerFeedback"
      [placeholder]="'Feedback installateur'"
      [client]="true"
      (answer)="executedFeedbackChanged($event)"
    ></textarea-input>
  </div>
  <div class="executed-images-container">
    <div
      *ngFor="let style of executionAssets"
      class="execution-asset clickable"
      [ngStyle]="style.style"
      (click)="openLightbox(style.productAsset)"
    >
      <mat-icon
        class="delete-button clickable"
        svgIcon="close"
        matTooltip="Verwijder foto"
        [matTooltipPosition]="'above'"
        (click)="deleteExecutionAsset($event, style)"
      ></mat-icon>
    </div>
  </div>
</div>
